import {Link, useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {getTimeLogs} from "../services/api";

export default function ListTimeLogs() {
    const { workDate } = useParams()
    
    const [workLogs, setWorkLogs] = useState([])
    useEffect(() => {
        getTimeLogs(workDate)
            .then(workLogs => {
                setWorkLogs(workLogs)
            })
            .catch(ex => {
                console.log("Error getting work logs: ", ex)
            })
    }, []);
    
    return (workLogs &&
        <>
        <table className="tabe striped">
            <thead>
            <tr>
                <th>Project</th>
                <th>Start</th>
                <th>End</th>
            </tr>
            </thead>
            <tbody>
            {workLogs.map(wl => {
                return (
                    <tr key={wl.timeLogId}>
                        <td><Link to={`/timelogs/edit/${wl.timeLogId}`}>{wl.project}</Link></td>
                        <td>{wl.start}</td>
                        <td>{wl.end}</td>
                    </tr>
                )
            })}
            </tbody>
        </table>

        <div className="mt-3 col-md-3">
            <Link to={"/timelogs/edit/new"} className="btn btn-primary">Add Item</Link>
        </div>
        </>
    )
}